import { MessageCircle } from "lucide-react";
import { useI18n } from "../contexts/LanguageContext";

const PHONE = "19739810532";

export default function WhatsAppFab() {
  const { t, lang } = useI18n();
  const msg = lang === "es"
    ? "Hola ENCES Global, me gustaría más información."
    : "Hi ENCES Global, I'd like more information.";
  const href = `https://wa.me/${PHONE}?text=${encodeURIComponent(msg)}`;
  return (
    <a
      href={href}
      target="_blank"
      rel="noreferrer"
      className="fixed bottom-6 right-6 md:bottom-8 md:right-8 z-50 group"
      data-testid="whatsapp-fab"
      aria-label={t.common.chatWithUs}
    >
      <span className="absolute right-16 top-1/2 -translate-y-1/2 hidden md:inline-flex bg-navy text-white text-sm font-semibold px-4 py-2 rounded-full shadow-lg whitespace-nowrap opacity-0 group-hover:opacity-100 transition-opacity">
        {t.common.chatWithUs}
      </span>
      <span className="inline-flex items-center justify-center w-14 h-14 rounded-full bg-whatsapp text-white shadow-2xl hover:scale-110 transition-transform">
        <MessageCircle size={26} />
      </span>
    </a>
  );
}
